(function (module) {
    'use strict';

    class AppStylesInPlaylist {
        getAppStylesInPlaylist(appsInPlaylist, allApps) {
            return _.map(appsInPlaylist, ({ id, duration }) => {
                const app = _.find(allApps, { id });
                const name = _.get(app, 'name');
                const styles = _.get(app, 'appTemplate.styles');
                const slug = _.get(app, 'appTemplate.slug');
                return { id, name, duration, styles, slug };
            });
        }
    }

    module.service('AppStylesInPlaylist', AppStylesInPlaylist);

})(angular.module('rocket.components'));
